import { render, staticRenderFns } from "./HomeButtons.vue?vue&type=template&id=bf11a578&scoped=true&"
import script from "./HomeButtons.vue?vue&type=script&lang=js&"
export * from "./HomeButtons.vue?vue&type=script&lang=js&"
import style0 from "./HomeButtons.vue?vue&type=style&index=0&id=bf11a578&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf11a578",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
